import React from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Fire, Time, Tools } from '../../../services'

import { Input, Button } from 'reactstrap'
import { Headerbar, Loader, ConfirmButton, TabsContainer, ListContainer, OrderingBox } from '../../Reusable'

import FadeIn from 'react-fade-in';
import AdsList from '../Ads/AdsList'
import CategoriesList from './CategoriesList'
import PosterItem from './PosterItem'

const tabs = [
  {
    title: 'Evènements',
    key: 'event',
  },
  {
    title: 'Bons plans',
    key: 'discount',
  },
  {
    title: 'Points de ventes',
    key: 'place',
  },
  {
    title: 'Notre sélection',
    key: 'selection',
  },
  {
    title: 'Catégories',
    key: 'categories',
  },
  {
    title: 'Poster',
    key: 'poster',
  },
]

interface Props {
  match: any;
}
const AdsScreen: React.FC<Props> = (props) => {

  const history = useHistory()
  const [error, setError] = React.useState('')
  const user = useSelector(state => state.authReducer.user)
  const [stats, setStats] = React.useState<any>({})
  const tab: any = props.match.params.tab || 'event'

  const loadStats = async () => {
    try {
      const element = await Fire.getGlobalStats()
      setStats(element)
    } catch (err) {
      setError("Impossible de charger les statistiques")
      console.warn(err)
    }
  }

  React.useEffect(() => {
    loadStats()
  }, [])

  const onFetchSelection = async () => {
    try {
      let ref = Fire.store().collection('ads')
        .where('published', '==', true)
      const list = await Fire.list(ref)
      const newList: any = []
      for (const item of list) {
        if (item.type === 'event') {
          if (!item.dateEnd)
            continue;
          const date = Fire.getDateFor(item.dateEnd)
          const now = new Date()
          if (date.getTime() < now.getTime())
            continue;
        }
        newList.push(item)
      }
      return newList
    } catch (err) {
      setError("Impossible de charger les sélections")
      console.warn(err)
    }
    return []
  }

  const onSaveSelection = async (items: any[]) => {
    try {
      const batch = Fire.batch()
      for (const item of items) {
        if (item.changed) {
          const itemRef = Fire.store().collection('ads').doc(item.id)
          batch.update(itemRef, { featured: item.changed })
        }
      }
      await batch.commit()
    } catch (err) {
      setError("Impossible de sauvegarder la sélection")
      console.warn(err)
    }
  }

  const renderContent = () => {
    if (tab === 'selection') {
      return (
        <OrderingBox
          title="Notre sélection"
          onFetch={onFetchSelection}
          onSave={onSaveSelection}
          />
      )
    }
    if (tab === 'categories') {
      return (
        <CategoriesList
          title={"Catégories"}
          />
      )
    }
    if (tab === 'poster') {
      return (
        <PosterItem />
      )
    }
    return (renderListing())
  }

  const renderListing = () => {
    const word = tab === 'event' ? 'évènements' : tab === 'discount' ? 'bons plans' : 'points de vente'

    return (
      <React.Fragment>
        
        <AdsList
          title={"Nos " + word + ""}
          type={tab}
          onSelect={(item: any) => history.push('/ads/' + tab + '/' + item.id)}
          onCreate={() => history.push('/ads/' + tab + '/new')}
          />
      </React.Fragment>
    )
  }

  return (
    <div className="wrapper">
      <Headerbar
        title={"Gestion des annonces"}
        />
      <div className="content-wrapper">
        <div className="content">
          <div className="container-fluid">

            <TabsContainer
              tab={tab}
              tabs={tabs}
              onSelect={(tab) => history.push('/app/' + tab.key)}
              />

              <FadeIn key={'fade-' + tab}>
                {renderContent()}
              </FadeIn>
            
          </div>
        </div>
      </div>
    </div>
  );
}

export default withRouter(AdsScreen)